<div class="container flex" role="search" data-qa="dashboard-search">
  <div class="search-heading">
    <div class="body-text">
      <span id="search-label">{{ searchLabel }}</span>
      <app-help-text-modal
        [modalTitle]="'Search Help Dialog'"
        [alignment]="'right'"
      >
        @if (context.dashboardHelpText) {
          <div class="institution-help-text">
            @if (context.dashboardHelpText.title) {
              <h2 [innerHTML]="context.dashboardHelpText.title"></h2>
            }
            @if (context.dashboardHelpText.content) {
              <span [innerHTML]="context.dashboardHelpText.content"></span>
            }
          </div>
        }
        <h2>Boolean Search</h2>
        <span class="emphasis">Note: </span
        ><span
          >Use of all caps for Boolean operators is intentional in the examples
          below and is required for a search to work as intended.</span
        >
        <ul>
          <li>
            A search term can be a single word like <em>sleep</em> or a phrase
            like <em>circadian rhythm</em>.
          </li>
          <li>
            This search uses <span class="emphasis">OR</span> as the default
            Boolean operator, so a search for <em>circadian rhythm</em> will
            return any works containing the term <em>circadian</em> or the term
            <em>rhythm</em>.
          </li>
          <li>
            A search for
            <em>circadian <span class="emphasis">AND</span> rhythm</em> will
            return only works that contain both terms.
          </li>
          <li>
            Adding quotation marks around a phrase, as in
            <em>"circadian rhythm,"</em> will return only works containing that
            exact multi-word phrase.
          </li>
          <li>
            Adding <span class="emphasis">NOT</span> before a term, as in
            <em>circadian <span class="emphasis">NOT</span> rhythm</em> will
            return only works that contain <em>circadian</em> but not
            <em>rhythm</em>.
          </li>
          <li>
            Putting terms inside parentheses allows for more complex searches
            like
            <em
              >(circadian <span class="emphasis">OR</span> rhythm)
              <span class="emphasis">AND</span> sleep
              <span class="emphasis">NOT</span> dream</em
            >.
          </li>
        </ul>
        <em
          >For more search syntax options, see
          <a href="https://lucene.apache.org/core/2_9_4/queryparsersyntax.html"
            >Lucene Query Syntax Documentation</a
          ></em
        >
      </app-help-text-modal>
    </div>
  </div>
  <div class="flex row align-items-end">
    <div class="search-input combined">
      <aa-tabs
        dataQaTag="tab-list"
        class="row mx-3"
        [tabDefinitions]="tabDefinitions"
        (tabSelect)="changeView($event)"
        [changeCurrentTab]="currentTab"
      ></aa-tabs>
      <div class="flex row align-items-center">
        <button
          [title]="
            'Search ' +
            (dashboardService.dashboardShortName ?
              dashboardService.dashboardShortName + ' '
            : '') +
            'Scholars by ' +
            ((selectedSearchType$ | async) === searchType.Name ?
              'Scholar Name'
            : 'Research Topic')
          "
          class="link transparent"
          (click)="requestSearch(input.value)"
          data-qa="dashboard-search-submit"
        >
          <fa-icon [icon]="faSearch"></fa-icon>
        </button>
        <input
          #input
          type="text"
          [title]="
            'Enter ' +
            ((selectedSearchType$ | async) === searchType.Name ?
              'Scholar Name'
            : 'Research Topic') +
            ' search term'
          "
          role="textbox"
          [ngModel]="_text"
          (ngModelChange)="text = $event"
          (keydown.enter)="requestSearch(input.value)"
          [placeholder]="
            'Search for ' +
            ((selectedSearchType$ | async) === searchType.Name ?
              'scholars'
            : 'research topics') +
            '...'
          "
          data-qa="dashboard-search-input"
        />
      </div>
    </div>
  </div>
</div>
